/* ––
 * ––– Imports
 * –––––––––––––––––––––––––––––––– */
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import PropTypes from 'prop-types';
import React from 'react';

/* ––
 * ––– Component
 * –––––––––––––––––––––––––––––––– */
function Header({ name = null, logo = null }) {
  /* –– Data fetching
   * –––––––––––––––––––––––––––––––– */
  const theme = useTheme();

  /* –– Render
   * –––––––––––––––––––––––––––––––– */
  return (
    <Container>
      <Grid container item sx={{ alignItems: 'center', py: 2 }}>
        <Grid
          item
          md={6}
          xs={12}
          sx={{
            display:                        'flex',
            '& img':                        { height: '50px' },
            [theme.breakpoints.down('sm')]: {
              justifyContent: 'center',
              '& img':        { height: '35px' },
            },
          }}
        >
          <img alt={name} src={logo} data-testid="header-company-logo" />
        </Grid>
        <Grid item md={6} sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end' }}>
          <Typography variant="h4" sx={{ color: 'primary.main', fontWeight: 'medium' }} data-testid="header-company-name">
            {name}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}

/* ––
 * ––– Props declaration
 * –––––––––––––––––––––––––––––––– */
Header.propTypes = {
  name: PropTypes.string,
  logo: PropTypes.string,
};

/* ––
 * ––– Exports
 * –––––––––––––––––––––––––––––––– */
export default Header;
